import React from "react";
import Modal from "../../../../../../common/_custom/Modal/Modal";
import style from "./ApproveRecordedPaymentModal.module.scss";
import { INFO_ICON_YELLOW_S3_LINK } from "../../../../../../constants/hostedS3IconLink/hostedIconS3Links";
import Button from "../../../../../../common/_custom/Button/Button";
import { ApproveModalDetails } from "../../RecordedPayments";
import { formatAmountToINR } from "../../../../../../util/utility";

type ApproveRecordedPaymentProps = {
  show: boolean;
  onClose: () => void;
  approveModalDetails: ApproveModalDetails;
  onApprove: () => Promise<void>;
};

const ApproveRecordedPaymentModal: React.FC<ApproveRecordedPaymentProps> = ({
  show,
  onClose,
  approveModalDetails,
  onApprove,
}) => {
  return (
    <Modal
      open={show}
      onClose={onClose}
      style={{
        height: "auto",
        maxHeight: "90vh",
        padding: "1.5rem",
        width: "35vw",
      }}
      closeIconStyle={{
        height: "14px",
        width: "14px",
        margin: "0.8rem 0.5rem 0 0",
      }}
    >
      <div className={style.repaymentModalContainer}>
        <div className={style.body}>
          <h1 className={style.heading}>Approve Payment?</h1>
          <div className={style.content}>
            <div className={style.listContainer}>
              <div>
                This payment of{" "}
                <span className={style.boldText}>
                  {formatAmountToINR(approveModalDetails.amount)}
                </span>{" "}
                by {approveModalDetails.investeeName} will settle:
              </div>
              {approveModalDetails.repaymentLinkages && (
                <ul className={style.list}>
                  {approveModalDetails.repaymentLinkages.map((linkage, index) => (
                    <React.Fragment key={index}>
                      {linkage.repaymentAmount > 0 && (
                        <li className={style.listItem}>
                          <span className={style.boldText}>Repayment ({linkage.transactionDate}): </span>
                          {formatAmountToINR(linkage.repaymentAmount)}
                        </li>
                      )}
                      {linkage.delayAmount > 0 && (
                        <li className={style.listItem}>
                          <span className={style.boldText}>Delay Charges ({linkage.transactionDate}): </span>
                          {formatAmountToINR(linkage.delayAmount)}
                        </li>
                      )}
                    </React.Fragment>
                  ))}
                  {approveModalDetails.totalExcessAmount > 0 && (
                    <li className={style.listItem}>
                      <span className={style.boldText}>Excess: </span>{formatAmountToINR(approveModalDetails.totalExcessAmount)}
                    </li>
                  )}
                </ul>
              )}
            </div>
            {approveModalDetails.potentialDuplicateTransaction != null && (
              <div className={style.warningContainer}>
                <img src={INFO_ICON_YELLOW_S3_LINK} alt={"info"} />
                <span>
                  A{" "}
                  <span className={style.boldText}>
                    {formatAmountToINR(approveModalDetails.amount)}
                  </span>{" "}
                  transaction{" "}
                  <span className={style.boldText}>
                    {approveModalDetails.potentialDuplicateTransaction?.utrNumber 
                      ? `(UTR ${approveModalDetails.potentialDuplicateTransaction.utrNumber})`
                      : ''
                    }
                  </span>{" "}
                  was already approved on
                  <span className={style.boldText}>
                    {" "}
                    {
                      approveModalDetails.potentialDuplicateTransaction
                        ?.approvalDate
                    }
                    .
                  </span>{" "}
                  Please verify to avoid duplicate entries.
                </span>
              </div>
            )}
          </div>
        </div>
        <div className={style.buttonContainer}>
          <Button
            text="Cancel"
            onClick={() => onClose()}
            variant={"whitePurple"}
            size="small"
            style={{
              width: "8rem",
              height: "2.5rem",
              padding: "0.625rem 1.875rem",
              fontSize: "0.625rem",
              fontFamily: "Gilroy-SemiBold"
            }}
          />
          <Button
            text="Proceed"
            onClick={async () => {
              await onApprove();
              onClose();
            }}
            variant={"blue"}
            size="small"
            style={{
              width: "8rem",
              height: "2.5rem",
              padding: "0.625rem 1.875rem",
              fontSize: "0.625rem",
              fontFamily: "Gilroy-SemiBold"
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ApproveRecordedPaymentModal;
